export const defaultBlocks = [
  { index: 0, color: "#FF1780", title: "meeting", emoji: "💬" },
  { index: 1, color: "#5C8AFF", title: "work", emoji: "🖥️" },
  { index: 2, color: "#FFC922", title: "break", emoji: "☕" },
  { index: 3, color: "#71C757", title: "inspection", emoji: "😱" },
  { index: 4, color: "#A757EF", title: "1 on 1", emoji: "👥" },
  { index: 5, color: "#FC7536", title: "lunch", emoji: "🍕" },
];
